// extracted by mini-css-extract-plugin
module.exports = {"heading":"shop-by-shape-component_heading__r6J0b","container":"shop-by-shape-component_container__VXmYq","cards":"shop-by-shape-component_cards__fbRl_"};